import {IsFeatureEnabledOrNot} from "../../FeatureToggles/FeatureEnabledOrNot";
import {ToggleList} from "../../FeatureToggles/toggleList";
import {useEffect, useState} from "react";
import {isNullOrUndefinedOrEmpty} from "../../common/utils";
import {UserGroupActions} from "../../pages/userGroups/model";
import {useDispatch, useSelector} from "react-redux";
import {Routes} from "../../common/Routes";
import {store} from "../../redux/store";
import {UserGroupType} from "../../pages/userGroups/service";
import {MenuAction, sendMenuEvent} from "../../components/matomoClient";
import {useHistory} from "react-router-dom";
import {AppSideBarPageActions} from "./model";

export const useAppSideBarController = () => {
  const isUserGroupFeatureToggleEnabled = IsFeatureEnabledOrNot(ToggleList.UserGroups);
  const isInformationAssetsFeatureToggleEnabled = IsFeatureEnabledOrNot(ToggleList.InformationAssets);
  const isUserGuideFeatureToggleEnabled = IsFeatureEnabledOrNot(ToggleList.UserGuide);
  const dispatch = useDispatch();
  const selectedSideBar = useSelector((rootState: ReturnType<typeof store.getState>) => rootState.appSideBar.selectedSideBar);
  const userGroupTypeNavList: {
    [k: string]: UserGroupType
  } = useSelector((rootState: ReturnType<typeof store.getState>) => rootState.userGroup.types.value);
  const [collapsed, setCollapsed] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (isUserGroupFeatureToggleEnabled && isNullOrUndefinedOrEmpty(userGroupTypeNavList)) {
      dispatch(UserGroupActions.getUserGroupTypes());
      dispatch(UserGroupActions.getAllUserGroupScope());
    }
  }, [isUserGroupFeatureToggleEnabled]);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    dispatch(AppSideBarPageActions.updateSideBarStatus(!collapsed));
  };

  const getSelectedMenuKey = () => {
    return selectedSideBar;
  };

  const shouldRenderUserGroupMenuOptions = () => !isNullOrUndefinedOrEmpty(userGroupTypeNavList) && isUserGroupFeatureToggleEnabled;

  const shouldRenderInformationAssetsMenuOption = () => isInformationAssetsFeatureToggleEnabled;

  const shouldRenderUserGuideMenuOption = () => isUserGuideFeatureToggleEnabled;

  const onUserGuideSideBarClick = () => {
    history.push(Routes.UserGuide.path);
    sendMenuEvent(MenuAction.UserGuide, "User Guide");
  }

  const onInformationAssetSideBarClick = () => {
    history.push(Routes.InformationAssets.path);
    sendMenuEvent(MenuAction.InformationAssets, "Information Assets");
  }

  const onUsersSideBarClick = () => {
    history.push(Routes.Users.usersList.path);
    sendMenuEvent(MenuAction.Users, "Users");
  }

  const onApplicationsSideBarClick = () => {
    history.push(Routes.Applications.path);
    sendMenuEvent(MenuAction.Applications, "Applications");
  }

  const onPoliciesSideBarClick = () => {
    history.push(Routes.Policies.path);
    sendMenuEvent(MenuAction.Policies, "Policies");
  }

  const onUserGroupSideBarClick = (userGroupId) => {
    history.push(
      `${Routes.UserGroups.basePath}/${userGroupTypeNavList[userGroupId].uniqueName}`,
    );
    sendMenuEvent(MenuAction.UserGroups, userGroupTypeNavList[userGroupId].titleName);
  }

  return ({
    toggleCollapsed,
    collapsed,
    getSelectedMenuKey,
    defaultKey: Routes.Applications.path,
    userGroupTypeNavList,
    shouldRenderUserGroupMenuOptions,
    shouldRenderInformationAssetsMenuOption,
    shouldRenderUserGuideMenuOption,
    onUserGuideSideBarClick,
    onInformationAssetSideBarClick,
    onUsersSideBarClick,
    onApplicationsSideBarClick,
    onPoliciesSideBarClick,
    onUserGroupSideBarClick
  });
};
